module.exports = __webpack_public_path__ + "media/images/smart_phone/products/kimutiudon2-b230e666feb9bfee1d8f63f9afd50348.jpeg";